/*
 * @Author: your name
 * @Date: 2021-06-22 13:18:16
 * @LastEditTime: 2021-06-25 15:34:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/router/views/index.js
 */
export default [
  {
    path: '/homePage',
    name: 'home',
    icon: 'HomeIcon',
    component: () => import('@/views/home/index.vue'),
    meta: {
      pageTitle: 'Home',
    },
  },
  {
    path: '/second-page',
    name: 'second-page',
    icon: 'FileIcon',
    component: () => import('@/views/SecondPage.vue'),
    meta: {
      pageTitle: 'Second Page',
      breadcrumb: [
        {
          text: 'Second Page',
          active: true,
        },
      ],
    },
  },
  {
    path: '/AccountSetting/index',
    name: 'second-page',
    icon: 'FileIcon',
    component: () => import('@/views/AccountSetting/index.vue'),
    meta: {
      pageTitle: 'Account Setting',
      breadcrumb: [
        {
          text: 'Account Setting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apply/list',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/apply/list.vue'),
    meta: {
      pageTitle: 'Apply Data',
    },
  },
  {
    path: '/apply/listByAuditor',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/apply/listByAuditor.vue'),
    meta: {
      pageTitle: 'Apply Data',
    },
  },
  // 用户应用
  {
    path: '/myApplication/notifications',
    name: 'notifications',
    icon: 'FileIcon',
    component: () => import('@/views/myApplication/notifications.vue'),
    meta: {
      pageTitle: 'Notifications',
    },
  },
  {
    path: '/myApplication/message',
    name: 'message',
    icon: 'FileIcon',
    component: () => import('@/views/myApplication/message.vue'),
    meta: {
      pageTitle: 'Message',
    },
  },
  {
    path: '/worker/apply/list',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/apply/list.vue'),
    meta: {
      pageTitle: 'Apply Data',
    },
  },
  // 工人流程列表
  {
    path: '/worker/flow/leaveJob/index',
    name: 'Leave Job(Worker)',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/leaveJob/index.vue'),
    meta: {
      pageTitle: 'Leave Job(Worker)',
    },
  },
  {
    path: '/worker/flow/courseApplication/index',
    name: 'Course Application(Worker)',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/courseApplication/index.vue'),
    meta: {
      pageTitle: 'Course Application(Worker)',
    },
  },
  {
    path: '/worker/flow/passportApplication/index',
    name: 'Passport',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/passportApplication/index.vue'),
    meta: {
      pageTitle: 'Passport',
    },
  },
  {
    path: '/worker/flow/workerForm/index',
    name: 'Worker Form',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/workerForm/index.vue'),
    meta: {
      pageTitle: 'Worker Form',
    },
  },
  {
    path: '/worker/flow/leave/index',
    name: 'Leave Application',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/leave/index.vue'),
    meta: {
      pageTitle: 'Leave Application',
    },
  },
  {
    path: '/worker/flow/turnSiteApply/index',
    name: 'Transfer Application',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/turnSiteApply/index.vue'),
    meta: {
      pageTitle: 'Transfer Application',
    },
  },
  {
    path: '/worker/flow/course/index',
    name: 'Course Application',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/course/index.vue'),
    meta: {
      pageTitle: 'Course Application',
    },
  },
  {
    path: '/worker/flow/transferDormitory/index',
    name: 'Transfer Dormitory',
    // icon: 'classroom'
    component: () => import('@/views/worker/flow/transferDormitory/index.vue'),
    meta: {
      pageTitle: 'Transfer Dormitory',
    },
  },
  {
    path: '/feedBackList/:back',
    name: 'FeedBackList',
    icon: 'FileIcon',
    component: () => import('@/views/FeedBack/feedBackList.vue'),
    meta: {
      pageTitle: 'Apply Data',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
  {
    path: '/processPrint',
    icon: 'HomeIcon',
    component: () => import('@/views/apply/components/processPrint.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/interviewPrint',
    icon: 'HomeIcon',
    component: () => import('@/views/staff/interview/components/interviewPrint.vue'),
    meta: {
      layout: 'full',
    },
  },
  // 工地主任考勤确认
  {
    path: '/directorExamine',
    icon: 'HomeIcon',
    component: () => import('@/views/worker/directorExamine/index.vue'),
    meta: {
      pageTitle: 'Director Examine',
      // layout: 'full',
    },
  },
  // 班组考勤汇总
  {
    path: '/sumByTeam',
    icon: 'HomeIcon',
    component: () => import('@/views/worker/attendSum/attendByTeam.vue'),
    meta: {
      pageTitle: 'Director Examine',
      // layout: 'full',
    },
  },
  {
    path: '/scheme',
    component: () => import('@/views/worker/attendanceScheme1/index.vue'),
    meta: {
      pageTitle: 'scheme',
      // layout: 'full',
    },
  },
]
